import React from "react";
import { toast } from "sonner";
import { Copy, Link2, Mail, MessageCircle, RefreshCw, XCircle } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { Card, LINK_STATE, Pill } from "./adminUi";
import { btn, fmtDate } from "../leads/PriorityBadge";

const CHANNEL = { email: "Email", whatsapp: "WhatsApp", copy: "Copiado" };

export const LinkPanel = ({ o, onChange }) => {
  const url = o.link?.token ? `${window.location.origin}/incorporacion/${o.link.token}` : "";
  const active = o.link_state === "active";
  const call = async (fn, ok) => {
    try { const r = await fn(); if (r?.data?.id) onChange(r.data); else onChange(); if (ok) toast.success(ok); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const mark = (channel) => api.post(`/admin/onboardings/${o.id}/link/sent`, { channel }).then(() => onChange()).catch(() => {});
  const copy = async () => { await navigator.clipboard.writeText(url); toast.success("Enlace copiado"); mark("copy"); };
  const wa = () => {
    const first = (o.player_name || "").split(" ")[0];
    const text = `Hola ${first}, aquí tienes tu enlace personal para empezar tu incorporación a QV Performance: ${url}`;
    window.open(`https://wa.me/${(o.phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
    mark("whatsapp");
  };

  return (
    <Card title="Enlace personal" testid="onb-link-card" right={<Pill map={LINK_STATE} k={o.link_state} testid="onb-link-state" />}>
      {url && (
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <input className="qv-input" readOnly value={url} style={{ flex: 1, opacity: active ? 1 : 0.45, textDecoration: active ? "none" : "line-through" }} data-testid="onb-link-url" />
        </div>
      )}
      {o.link?.expires_at && <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 12 }}>Creado {fmtDate(o.link.created_at)} · Caduca {fmtDate(o.link.expires_at)}{o.link.invalidated_at && ` · Invalidado ${fmtDate(o.link.invalidated_at)}`}</div>}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {active ? (<>
          <button style={btn("transparent")} onClick={copy} data-testid="onb-link-copy"><Copy size={14} /> Copiar</button>
          <button style={btn("transparent")} onClick={() => call(() => api.post(`/admin/onboardings/${o.id}/link/send-email`), "Email enviado")} disabled={!o.email} title={o.email ? "" : "Añade un email"} data-testid="onb-link-email"><Mail size={14} /> Enviar por email</button>
          <button style={btn("#25D366")} onClick={wa} disabled={!o.phone} data-testid="onb-link-whatsapp"><MessageCircle size={14} /> WhatsApp</button>
          <button style={btn("transparent")} onClick={() => window.confirm("¿Generar un enlace nuevo? El actual dejará de funcionar.") && call(() => api.post(`/admin/onboardings/${o.id}/link`), "Enlace nuevo generado")} data-testid="onb-link-regenerate"><RefreshCw size={14} /> Regenerar</button>
          <button style={{ ...btn("transparent"), color: "#f87171" }} onClick={() => window.confirm("¿Invalidar el enlace? Dejará de funcionar inmediatamente.") && call(() => api.post(`/admin/onboardings/${o.id}/link/invalidate`), "Enlace invalidado")} data-testid="onb-link-invalidate"><XCircle size={14} /> Invalidar</button>
        </>) : (
          <button style={btn("#dc2626")} onClick={() => call(() => api.post(`/admin/onboardings/${o.id}/link`), "Enlace generado")} data-testid="onb-link-generate"><Link2 size={14} /> {url ? "Generar enlace nuevo" : "Generar enlace"}</button>
        )}
      </div>
      {!o.phone && active && <div style={{ fontSize: 12, color: "#737373", marginTop: 8 }}>Añade un teléfono para enviarlo por WhatsApp.</div>}
      {(o.link_sends || []).length > 0 && (
        <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 12 }} data-testid="onb-link-sends">
          Envíos: {o.link_sends.slice(-5).reverse().map((s) => `${CHANNEL[s.channel] || s.channel} ${fmtDate(s.at)}`).join(" · ")}
        </div>
      )}
    </Card>
  );
};
